export const PROMOTION_STATUS = {
  scheduled: { label: 'Agendada', template: 'warning' },
  paused: { label: 'Pausada', template: 'warning' },
  running: { label: 'Ativa', template: 'success' },
  finished: { label: 'Finalizada', template: 'info' },
  canceled: { label: 'Cancelada', template: 'danger' }
}
